// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7rFZI","left":"styles_left__Uhx1x"};